import React, { useRef } from "react";
import { Link } from "react-router-dom";

export default function SafeScrollLink({ to, children, ...props }) {
    const touchStartY = useRef(0);
    const touchStartX = useRef(0);
    const isScrolling = useRef(false);

    return (
        <Link
            to={to}
            {...props}
            onTouchStart={(e) => {
                const touch = e.touches[0];
                touchStartX.current = touch.clientX;
                touchStartY.current = touch.clientY;
                isScrolling.current = false;
            }}
            onTouchMove={(e) => {
                const touch = e.touches[0];
                const dx = Math.abs(touch.clientX - touchStartX.current);
                const dy = Math.abs(touch.clientY - touchStartY.current);
                if (dx > 10 || dy > 10) isScrolling.current = true; // moved = scroll
            }}
            onTouchEnd={(e) => {
                if (isScrolling.current) {
                    e.preventDefault(); // cancel click
                    e.stopPropagation();
                }
            }}
        >
            {children}
        </Link>
    );
}
